import { FC } from "react";
import PolicyDividendsTable from "./PolicyDividendsTable";

type PolicyDividendsWrapperProps = {
  insuredId?: number;
  tabKey: string;
};
const PolicyDividendsWrapper: FC<PolicyDividendsWrapperProps> = ({
  insuredId,
}) => {
  return (
    <div>
      <PolicyDividendsTable insuredId={insuredId} />
    </div>
  );
};

export default PolicyDividendsWrapper;
